var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Shipping = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M15,7 L3,7 L3,6 L15,6 C15.5522847,6 16,6.44771525 16,7 L16,8 L18.190983,8 C18.5697551,8 18.9160182,8.21400238 19.0854102,8.5527864 L20.8944272,12.1708204 C20.9638549,12.3096758 21,12.4627889 21,12.618034 L21,16 C21,16.5522847 20.5522847,17 20,17 L19,17 C19,18.1045695 18.1045695,19 17,19 C15.8954305,19 15,18.1045695 15,17 L9,17 C9,18.1045695 8.1045695,19 7,19 C5.8954305,19 5,18.1045695 5,17 L3,17 L3,16 L5.26760632,15.9999275 C5.61342606,15.4021661 6.25974756,15 7,15 C7.74025244,15 8.38657394,15.4021661 8.73239368,15.9999275 L15.2676063,15.9999275 C15.6134261,15.4021661 16.2597476,15 17,15 C17.7402524,15 18.3865739,15.4021661 18.7323937,15.9999275 L20,16 L20,13 L15,13 L15,7 Z M17,16 C16.4477153,16 16,16.4477153 16,17 C16,17.5522847 16.4477153,18 17,18 C17.5522847,18 18,17.5522847 18,17 C18,16.4477153 17.5522847,16 17,16 Z M7,16 C6.44771525,16 6,16.4477153 6,17 C6,17.5522847 6.44771525,18 7,18 C7.55228475,18 8,17.5522847 8,17 C8,16.4477153 7.55228475,16 7,16 Z M9,13 L9,14 L3,14 L3,13 L9,13 Z M16,9 L16,12 L19.691,12 L18.190983,9 L16,9 Z M7,10 L7,11 L3,11 L3,10 L7,10 Z" })));
};
Shipping.displayName = 'Shipping';
export default Shipping;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Shipping.js.map